import { DatePipe, NumberSymbol } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MdbTablePaginationComponent, MdbTableDirective } from 'angular-bootstrap-md';
import { LocalesModule } from '../../modelo/locales/locales.module';
import { crecimientoModule } from '../../modelo/usuario/crecimiento';
import { LoginService } from '../../servicios/login.service';
import { ReporteService } from '../../servicios/reporte.service';

@Component({
  selector: 'app-reporte-crecimiento',
  templateUrl: './reporte-crecimiento.component.html',
  styleUrls: ['./reporte-crecimiento.component.css']
})
export class ReporteCrecimientoComponent implements OnInit {
  alertService: any;
  id_pais:string;
  anio_actua:number;
  anio_anterior:number;
  total_act:number;
  total_ant:number;
  total_dev_ac:number;
  total_venta:number;
  total_dev_ant:number;
  local:string;
  anios:number [];
  listaLocales:LocalesModule[];
  usuario: string;
  habilitar:boolean;
  anio:number;
  id:string;
  tipo: [];
  meses: [];
  datosCrecimiento: crecimientoModule[];
  datosDevolucion: crecimientoModule[];
  mesesAnio = [
    { id: 1, name: 'Enero' },
    { id: 2, name: 'Febrero' },
    { id: 3, name: 'Marzo' },
    { id: 4, name: 'Abril' },
    { id: 5, name: 'Mayo' },
    { id: 6, name: 'Junio' },
    { id: 7, name: 'Julio' },
    { id: 8, name: 'Agosto' },
    { id: 9, name: 'Septiembre' },
    { id: 10, name: 'Octubre' },
    { id: 11, name: 'Noviembre' },
    { id: 12, name: 'Diciembre' },
  ];
  mesesMostrar:[];
    aniosselec:string[];
    meseSelec:string[];
    fechaInicia:Date;
    fechaFin:Date;
  
  @ViewChild(MdbTablePaginationComponent) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective) mdbTable: MdbTableDirective;
  @ViewChild(MdbTableDirective) mdbTableDos: MdbTableDirective;



  @ViewChild(MdbTablePaginationComponent) mdbTablePaginationD: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective) mdbTableD: MdbTableDirective;

  constructor(private datePipe: DatePipe,private api: ReporteService,private apiLogin: LoginService) { }


  listarMeses(){
    this.mesesMostrar =[];
    this.mesesAnio.forEach(element => {
        this.mesesMostrar.push(element as never);
      });
    }

    fieldsChangeMes(ev):void {

      if(ev.target.checked){
     this.meseSelec.push(ev.target.defaultValue);
     //this.anio=ev.target.defaultValue
      }else{
        const index: number =this.meseSelec.indexOf(ev.target.defaultValue);
        if (index !== -1) {
          this.meseSelec.splice(index, 1);
       
      }  
      }
     // this.cargarInformacion();
   
    }

buscar(){
  this.cargarInformacion();
}

onChangeLocal($event: Event) {
  
  localStorage.setItem('id', this.id);
  this.listaLocales.forEach(item => {
    if (item.id.toString() ==this.id){
      localStorage.setItem('nombreLocal', item.Nombre_ClientesFinales);  
      this.usuario=localStorage.getItem('nombre');
    this.local=localStorage.getItem('nombreLocal');
    }
    
  });

  this.anio_actua=new Date().getFullYear();
  this.anio_anterior=this.anio_actua-1;
  this.id_pais=localStorage.getItem("id_pais");
 
 this.listarAnioxLocal();
  this.aniosselec=[];
  this.meseSelec=[];

  }

  
  fieldsChange(ev):void {

    if(ev.target.checked){
      this.anio=ev.target.defaultValue;
      this.anio_actua=this.anio;
      this.anio_anterior=this.anio-1
      this.aniosselec.push(ev.target.defaultValue);
       }else{
         const index: number =this.aniosselec.indexOf(ev.target.defaultValue);
         if (index !== -1) {
           this.aniosselec.splice(index, 1);
        
       }  
       }
    
this.listarMeses();
    
  }


  buscarFecha(){

   this.listarCrecimientoFecha( this.datePipe.transform(this.fechaInicia, "yyyy-MM-dd"),
   this.datePipe.transform(this.fechaFin, "yyyy-MM-dd"));

   this.listarDevolucionFecha( this.datePipe.transform(this.fechaInicia, "yyyy-MM-dd"),
   this.datePipe.transform(this.fechaFin, "yyyy-MM-dd"));


  }

  ngOnInit(): void {
    currentYear:Date;
    //this.anio_actua=new Date().getFullYear();
    //this.anio_anterior=this.anio_actua-1;
    this.id_pais=localStorage.getItem("id_pais");
   
    this.listarAnioxLocal();
    this.aniosselec=[];
    this.meseSelec=[];
    this.cargarLocales();
  }



  cargarInformacion(){
    let meses="";
    
    let mesesOrderna: number[];
   
    mesesOrderna=[];
    
    this.meseSelec.forEach(element => {
          meses=meses+element+",";
          mesesOrderna.push(Number.parseInt(element));
    });
    if (meses.length>0){
    meses=meses+'0';
    }else{
      meses="''"
    }


    this.listarCrecimiento(meses);
    this.listarDevolucion(meses);
   
  }
 
listarAnioxLocal(){
  this.api.aniosCrecimiento(this.id_pais).subscribe((
    data: []) => {
    this.anios = data;
    console.log(this.anios);
  },
    err => this.alertService.danger('Error no hay  conexion..')
  );
}

  listarCrecimiento(meses){
    this.total_act=0;
    this.total_ant=0;
    this.total_venta=0;
    this.api.crecimientoVentas(this.id_pais,meses,this.anio).subscribe((
      data: []) => {
      this.datosCrecimiento = data;
     this.datosCrecimiento.forEach(element => {
      this.total_act=this.total_act+Number.parseFloat(this.validarNumeros(element.venta_actu))
      this.total_ant=this.total_ant+Number.parseFloat(this.validarNumeros(element.venta_ant))
     });    
     this.total_venta= ((this.total_act/this.total_ant)-1)*100
      this.mdbTable.setDataSource(this.datosCrecimiento);
      this.mdbTable.dataSourceChange();
    },
      err => this.alertService.danger('Error no hay  conexion..')
    );

  }

  listarCrecimientoFecha(fechainicio,fechafinal){
    this.total_act=0;
    this.total_ant=0;
    this.total_venta=0;
    this.api.crecimientoVentasFecha(this.id_pais,this.anio,fechainicio,fechafinal).subscribe((
      data: []) => {
      this.datosCrecimiento = data;
     this.datosCrecimiento.forEach(element => {
      this.total_act=this.total_act+Number.parseFloat(this.validarNumeros(element.venta_actu))
      this.total_ant=this.total_ant+Number.parseFloat(this.validarNumeros(element.venta_ant))
     });    
     this.total_venta= ((this.total_act/this.total_ant)-1)*100
      this.mdbTable.setDataSource(this.datosCrecimiento);
      this.mdbTable.dataSourceChange();
    },
      err => this.alertService.danger('Error no hay  conexion..')
    );

  }


  



public  cargarLocales(){
  this.apiLogin.locales(localStorage.getItem("id_pais"))
  .subscribe((
    data: LocalesModule[]) => {
    this.listaLocales = data;
    this.usuario=localStorage.getItem("nombre");
    this.local=localStorage.getItem("nombreLocal");
    this.id=localStorage.getItem("local");
    if (localStorage.getItem("rol")=='MaxiPan' || localStorage.getItem("rol")=='Gerencia CF' )
  {     this.habilitar=false;
  }else{
   this.habilitar=true;
  }
   console.log(this.listaLocales);
   this.listaLocales.forEach(item => {
    if (item.id.toString() ==this.id){
      localStorage.setItem('nombreLocal', item.Nombre_ClientesFinales);  
    }
    
  });
  },
 // err =>  this.alertService.danger('Error no hay  conexion..')
  );
}
  
  listarDevolucion(meses){
    this.api.decrecimientoDevolucion(this.id_pais,meses,this.anio).subscribe((
      data: []) => {
      this.datosDevolucion = data;

      this.datosDevolucion.forEach(element => {
        let porcentaje= Number.parseFloat(
          element.dev.toString());
          let valor=Math.round((porcentaje + Number.EPSILON) * 100) /100 
        if (valor>=0 && valor<10){
          element.color="white"
        }
        if (valor>=10 && valor<15){
         element.color="yellow"
       }
       if (valor>=15 && valor<30){
         element.color="orange"
       }
       if (valor>=30){
         element.color="red"
       }


      
      });



      this.datosDevolucion.forEach(element => {
        let porcentaje= Number.parseFloat(
          element.dev_actu.toString());
          let valor=Math.round((porcentaje + Number.EPSILON) * 100) /100 
        if (valor>=0 && valor<10){
          element.color1="white"
        }
        if (valor>=10 && valor<15){
         element.color1="yellow"
       }
       if (valor>=15 && valor<30){
         element.color1="orange"
       }
       if (valor>=30){
         element.color1="red"
       }


      
      });

      this.datosDevolucion.forEach(element => {
        let porcentaje= Number.parseFloat(
          element.dev_ant.toString());
          let valor=Math.round((porcentaje + Number.EPSILON) * 100) /100 
        if (valor>=0 && valor<10){
          element.color2="white"
        }
        if (valor>=10 && valor<15){
         element.color2="yellow"
       }
       if (valor>=15 && valor<30){
         element.color2="orange"
       }
       if (valor>=30){
         element.color2="red"
       }


      
      });
     

     
      this.mdbTableDos.setDataSource(this.datosDevolucion);
      this.mdbTableDos.dataSourceChange();
    },
      err => this.alertService.danger('Error no hay  conexion..')
    );

  }

  listarDevolucionFecha(fechainica,fechafin){
    this.api.crecimientoDevolucionFecha(this.id_pais,this.anio,fechainica,fechafin).subscribe((
      data: []) => {
      this.datosDevolucion = data;

      this.datosDevolucion.forEach(element => {
        let porcentaje= Number.parseFloat(
          element.dev.toString());
          let valor=Math.round((porcentaje + Number.EPSILON) * 100) /100 
        if (valor>=0 && valor<10){
          element.color="white"
        }
        if (valor>=10 && valor<15){
         element.color="yellow"
       }
       if (valor>=15 && valor<30){
         element.color="orange"
       }
       if (valor>=30){
         element.color="red"
       }


      
      });



      this.datosDevolucion.forEach(element => {
        let porcentaje= Number.parseFloat(
          element.dev_actu.toString());
          let valor=Math.round((porcentaje + Number.EPSILON) * 100) /100 
        if (valor>=0 && valor<10){
          element.color1="white"
        }
        if (valor>=10 && valor<15){
         element.color1="yellow"
       }
       if (valor>=15 && valor<30){
         element.color1="orange"
       }
       if (valor>=30){
         element.color1="red"
       }


      
      });

      this.datosDevolucion.forEach(element => {
        let porcentaje= Number.parseFloat(
          element.dev_ant.toString());
          let valor=Math.round((porcentaje + Number.EPSILON) * 100) /100 
        if (valor>=0 && valor<10){
          element.color2="white"
        }
        if (valor>=10 && valor<15){
         element.color2="yellow"
       }
       if (valor>=15 && valor<30){
         element.color2="orange"
       }
       if (valor>=30){
         element.color2="red"
       }


      
      });
     

     
      this.mdbTableDos.setDataSource(this.datosDevolucion);
      this.mdbTableDos.dataSourceChange();
    },
      err => this.alertService.danger('Error no hay  conexion..')
    );

  }

  validarNumeros(numero){
    if (!numero){
      return 0;
    }else{
      return numero;
    }
  }
}
